// Centralized authentication configuration
export const AUTH_CONFIG = {
  ADMIN_EMAIL: 'admin@gmail.com',
  ADMIN_PASSWORD: 'admin'
};
